export { default as SaveSearchButton } from './SaveSearchButton';



// WEBPACK FOOTER //
// ./src/containers/SearchPage/SearchSection/SaveSearchButton/index.ts